// const API_IP = "http://100.120.95.83:3004";
// const API_IP = "http://192.168.1.63:3004";
const API_IP = "https://icaresolutions.ca:3004";
export { API_IP };
